<div class="page-wrapper page-wrapper-dashboard">
  <div class="page-container">
    <app-header [showAvatar]="false" title="Dashboard" [useTabs]="false">
    </app-header>
    <div class="body">
      <div class="body-container">
        <div class="page-main">

          <!-- Store Performance -->
          <app-store-performance></app-store-performance>
          <!-- Payment Activity -->
          <app-billing-operation-dashboard></app-billing-operation-dashboard>
          <!-- Sales Channels Activity -->
          <app-sales-channels-dashboard></app-sales-channels-dashboard>
        </div>
      </div>
    </div>
  </div>
</div>
